import { AI_SERVICE_URL } from '@/config/constants';
import { ENDPOINT } from './meta.api';
import fetchIntercept from 'fetch-intercept';
import { getSsoLoginOptions } from 'utils/auth/ssoPreference';

// URLs that should receive an Auth0 bearer token automatically. Both our
// own backend (ENDPOINT) and the separate ai-services deployment
// (AI_SERVICE_URL) sit behind the same Auth0 audience, so callers don't
// need to attach the token manually.
const isAuthenticatedUrl = (url) =>
    typeof url === 'string' &&
    (url.includes(ENDPOINT) ||
        (AI_SERVICE_URL && url.startsWith(AI_SERVICE_URL)));

const registerAuthenticatedFetchInterceptor = ({
    getAccessTokenSilently,
    loginWithRedirect,
}) => {
    return fetchIntercept.register({
        request: async (url, config) => {
            if (isAuthenticatedUrl(url)) {
                try {
                    const accessToken = await getAccessTokenSilently();
                    // Preserve caller-set headers (Content-Type, custom
                    // headers, etc.); just ensure Authorization is set and
                    // default Content-Type to JSON when missing.
                    const headers = new Headers(config.headers || {});
                    if (!headers.has('Content-Type')) {
                        headers.set('Content-Type', 'application/json');
                    }
                    headers.set('Authorization', `Bearer ${accessToken}`);
                    config.headers = headers;
                } catch (err) {
                    loginWithRedirect({
                        ...getSsoLoginOptions(),
                        appState: { returnTo: window.location.pathname },
                    });
                }
            }

            return [url, config];
        },
    });
};

export default registerAuthenticatedFetchInterceptor;
